import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  FieldRadioImageWrapper
} from './styled'

export class FieldRadioImage extends React.PureComponent {
  render () {
    const {
      className,
      id,
      name,
      value,
      isChecked,
      onChange,
      srcIcon,
      label,
      isCategory
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'field-radio-image',
      {'is-category': isCategory},
      className
    )

    return (
      <FieldRadioImageWrapper
        className={classes}
      >
        <input className='field-radio-image-value'
          type='radio'
          id={id}
          name={name}
          value={value}
          checked={isChecked}
          onChange={onChange}
        />
        <label className='field-radio-image-label'
          htmlFor={id}
        >
          <img
            className='field-radio-image-icon'
            src={srcIcon}
            alt='Icon'
          />
          {label}
        </label>
      </FieldRadioImageWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
